'use client';

/**
 * AnalyticsExplorerCoverageCard — explorer report-picker for
 * `sel:coverage` (mode9). Click row → `setExplorerSelection('coverage')`;
 * the canvas routes to the mode9_coverage preset.
 *
 * Reuses the shared ReportTile primitive (kebab → Copy report / Download
 * capture). Chrome reads from `response.labels` shipped by
 * `analytics_coverage` — deduped by React Query with the canvas cards.
 *
 * @see klyde_edge/ui_config/composition/cards/analytics.py — content_key="analytics_explorer_coverage"
 * @see klyde_edge/ui_config/labels/coverage.py — cov_sel_*, action_*
 */

import { Gauge } from 'lucide-react';
import { useCoverageView } from '@/components/canvas/cards/analytics/use-coverage-view';
import { ReportTile } from '../system_obeya/report-tile';

export function AnalyticsExplorerCoverageCard() {
  const { data } = useCoverageView();
  const L = data?.labels ?? {};

  return (
    <ReportTile
      selection="coverage"
      label={L.cov_sel_label ?? 'Capability Coverage'}
      description={L.cov_sel_description}
      Icon={Gauge}
      copyReportLabel={L.action_copy_report}
      downloadCaptureLabel={L.action_download_capture}
      menuLabel={L.report_menu_label}
      mode="mode9"
      contentKey="analytics_explorer_coverage"
    />
  );
}
